import moment from 'moment'
import {
  PriceCoefficientAPI,
  PriceCoefficientTable
} from '../../../api/Argentia/endpoints/priceCoefficients/model/PriceCoefficient'

export const priceCoefficientsAPIListMapper = (priceCoefficient: PriceCoefficientAPI[]) => {
  return priceCoefficient.map(priceCoefficientsAPIItemMapper)
}

export const priceCoefficientsAPIItemMapper = (
  priceCoefficient: PriceCoefficientAPI
): PriceCoefficientTable => {
  return {
    ...priceCoefficient,
    startDate: moment(priceCoefficient.startDate).toDate(),
    endDate: moment(priceCoefficient.endDate).toDate()
  }
}

export const consolidateNullValues = (coefficient: any): PriceCoefficientTable => {
  // La tabla devuelve "" cuando es un valor null, por lo que hay que convertirlo a undefined
  return {
    ...coefficient,
    p1:
      coefficient.p1 != null && coefficient.p1 !== '' && coefficient.p1 >= 0
        ? coefficient.p1
        : undefined,
    p2:
      coefficient.p2 != null && coefficient.p2 !== '' && coefficient.p2 >= 0
        ? coefficient.p2
        : undefined,
    p3:
      coefficient.p3 != null && coefficient.p3 !== '' && coefficient.p3 >= 0
        ? coefficient.p3
        : undefined,
    p4:
      coefficient.p4 != null && coefficient.p4 !== '' && coefficient.p4 >= 0
        ? coefficient.p4
        : undefined,
    p5:
      coefficient.p5 != null && coefficient.p5 !== '' && coefficient.p5 >= 0
        ? coefficient.p5
        : undefined,
    p6:
      coefficient.p6 != null && coefficient.p6 !== '' && coefficient.p6 >= 0
        ? coefficient.p6
        : undefined
  }
}
